<template>
  <div class="page_content">
    <template v-if="component_loading">
      <div class="component_loader">
        <spinner :status="component_loading"></spinner>
      </div>
    </template>
    <template>
      <div class="boxi padding-regulation">
        <div v-if="regulations.length > 0">
          <div
            class="document_item text-center"
            v-for="document_item in regulations"
            :key="document_item.id"
          >
            <a
              target="_blank"
              :href="
                SERVER_URL +
                'company-regulations/' +
                document_item.file +
                '#toolbar=0'
              "
            >
              <div class="document_icon">
                <img src="/images/document.svg" width="50px" />
              </div>
              <div class="document_name">
                <div class="text-center">
                  <p>{{ document_item.title }}</p>
                  <!-- <p class="dep_info">Department: {{ document_item.department ? document_item.department.name : 'All departments' }}</p> -->
                </div>
              </div>
              <div v-if="general_settings_contracts_mark_as_read">
                <div
                  v-if="!isAlreadyReaded(document_item.id)"
                  class="on-hover d-flex justify-content-center align-items-center"
                  @click="markRegulationAsRead(document_item.id)"
                >
                  <p class="px-2">Mark as read</p>
                  <div class="hr-icon-ios-checkbox-outline"></div>
                </div>
                <div
                  v-else
                  class="on-hover d-flex justify-content-center align-items-center"
                >
                  <p class="px-2">Marked as read</p>
                  <div class="hr-icon-ios-checkmark"></div>
                </div>
              </div>
            </a>
            <hr />
          </div>
        </div>
        <div v-if="regulations.length === 0" class="textinBox text-center">
          <br />
          <p>No business regulation found</p>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import { VueEditor } from 'vue2-editor'

export default {
  components: {
    VueEditor,
  },

  data() {
    return {
      component_loading: false,
      regulations: [],
      readed_regulations: [],

      general_settings_contracts_mark_as_read: false,
    }
  },

  methods: {
    getCompanyRegulations: function () {
      this.$store
        .dispatch('employee_data/companysettings/show_company_regulation')
        .then(response => {
          this.regulations = response.data
        })
    },
    getReadedRegulations: function () {
      this.$store
        .dispatch('employee_data/companysettings/fetch_readed_regulations')
        .then(response => {
          this.readed_regulations = response.data
        })
    },
    markRegulationAsRead: function (id) {
      this.$store
        .dispatch('employee_data/companysettings/mark_regulation_as_red', id)
        .then(response => {
          this.getReadedRegulations()
        })
    },
    isAlreadyReaded: function (id) {
      const item = this.readed_regulations.find(
        item => item.regulation_id === id
      )
      if (item) {
        return true
      }
      return false
    },
  },

  created() {
    this.getCompanyRegulations()
    this.$store
      .dispatch('company_data/general_settings/get_company_general_settings')
      .then(res => {
        if (res.data.contracts_notification_and_read) {
          this.general_settings_contracts_mark_as_read = true
          this.getReadedRegulations()
        }
      })
  },
}
</script>

<style lang="scss">
.padding-regulation {
  padding: 40px 80px !important;
}
</style>
